<template>
  <div class="container">
    登出成功，将在{{times}}秒内返回...
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
export default {
  data () {
    return {
      times: 5
    }
  },
  created () {
    this.timer = setInterval(() => {
      this.times--
      if (this.times === 0) {
        clearInterval(this.timer)
        window.location.href = commonUtils.getExtraSite()
      }
    }, 1000)
  }
}
</script>

<style scoped>
.container{
  margin-top:100px;
  width: 100vw;
  text-align: center;
  font-size: 18px;
}
</style>
